function getWizardData () {
	return {
		client_type: 'Web'
	}
}

function getTagData (payload) {
	return {
		video_type: payload.playMode === 'pano' ? 'pano' : 'hd',
		sport_type: payload.event.sportType,
		event_type: payload.event.type,
		permission: 'admin',
		event_name: payload.event.title,
		event_id: payload.event.eventId,
		event_status: payload.event?.status || '',
		client_type: 'Web'
	}
}

const getEventData = (payload) => {
	const { mainEvent, activePlayback } = payload

	return {
		event_id: mainEvent?.eventId || '',
		event_name: mainEvent?.title || '',
		sport_type: mainEvent?.sportType || '',
		event_status: mainEvent?.status || '',
		video_category: activePlayback.type || '',
		video_name: activePlayback.title || '',
		video_type: payload.playMode === 'pano' ? 'pano' : 'hd',
		video_id: activePlayback.id || '',
		navigation_page: payload.navigationPage || '',
		client_type: 'Web',
		...(payload.clubName && { team_name: payload.clubName })
	}
}

const getTagMemberData = (payload) => {
	const { activePlayback, mainEvent } = payload

	return {
		client_type: 'Web',
		video_category: payload.isTag ? 'tag' : activePlayback.type || '',
		video_id: activePlayback.id || '',
		event_status: mainEvent?.status || ''
	}
}

export default {
	SearchTags: {
		event: 'Search Tags',
		getData: (payload) => {
			return {
				sportType: payload.event.sportType,
				eventName: payload.event.title,
				eventID: payload.event.eventId,
				client_type: 'Web'
			}
		}
	},
	HideSuggestedMoment: {
		event: 'Click On Hide Suggested Moment',
		getData: (payload) => {
			return {
				suggestedFilter: payload.suggestedFilter,
				...getTagData(payload)
			}
		}
	},
	SelectALlFilterTags: {
		event: 'Select All Filter Tags',
		getData: (payload) => {
			return {
				SelectAllTypeTags: payload.typeTags,
				SelectAllPlayerTags: payload.playerTags,
				...getTagData(payload)
			}
		}
	},
	TagFilterChange: {
		event: 'Tag Filter Change',
		getData: (payload) => {
			return {
				tagActive: payload.tagActive,
				tagName: payload.tagName,
				...getTagData(payload)
			}
		}
	},
	TagsFilterRemoveALl: {
		event: 'Remove All Filter Tags',
		getData: (payload) => {
			return {
				removeAllTags: payload.removeAllTags,
				...getTagData(payload)
			}
		}
	},
	SportSelected: {
		event: 'Wizard: Sport Selected',
		getData: (sport) => {
			return {
				title: sport.title,
				...getWizardData()
			}
		}
	},
	CameraSelected: {
		event: 'Wizard: Camera Selected',
		getData: (camera) => {
			return {
				id: camera.id,
				type: (!camera.price ? 'I have my own/' : '') + camera.metadata.cameraType,
				...getWizardData()
			}
		}
	},
	AccessoriesChecked: {
		event: 'Wizard: Accessories Checked',
		getData: (accessories) => {
			return Object.assign({ ...getWizardData() }, accessories.map(item => ({
				id: item.id,
				name: item.name
			})))
		}
	},
	AccessoriesQuantityChange: {
		event: 'Wizard: Accessories Quantity Changed',
		getData: (accessories) => {
			return Object.assign({ ...getWizardData() }, accessories.map(item => ({
				id: item.id,
				name: item.name,
				quantity: item.quantity
			})))
		}
	},
	AccessoriesInfoClicked: {
		event: 'Wizard: Accessories Info Clicked UI',
		getData: (accessory) => {
			return {
				id: accessory.id,
				name: accessory.name,
				...getWizardData()
			}
		}
	},
	AccessoriesSelected: {
		event: 'Wizard: Accessories Selected',
		getData: (accessories) => {
			return Object.assign({ ...getWizardData() }, accessories.map(item => ({
				id: item.id,
				name: item.name,
				quantity: item.quantity
			})))
		}
	},
	SubscriptionSelected: {
		event: 'Wizard: Subscription Selected',
		getData: (subscription) => {
			return {
				id: subscription.id,
				subscription_name: (subscription.intervalCount === 1 ? 'Monthly' : subscription.intervalCount === 12 ? 'Yearly' : 'Two-years') + '/' + subscription.metadata.type,
				...getWizardData()
			}
		}
	},
	WizardSubmitClicked: {
		event: 'Wizard: Submit Clicked UI',
		getData: getWizardData
	},
	WizardSubmitError: {
		event: 'Wizard: Submit Error',
		getData: (error) => {
			return {
				error,
				...getWizardData()
			}
		}
	},
	WizardSignUpSuccess: {
		event: 'Wizard: Sign Up Successfully',
		getData: getWizardData
	},
	WizardSignUpError: {
		event: 'Wizard: Sign Up Error',
		getData: (error) => {
			return {
				error,
				...getWizardData()
			}
		}
	},
	WizardCheckoutClicked: {
		event: 'Wizard: Checkout Clicked UI',
		getData: getWizardData
	},
	WizardCheckoutError: {
		event: 'Wizard: Failed To Complete Checkout',
		getData: getWizardData
	},
	WizardStep: {
		event: 'Wizard Step',
		getData: (payload) => {
			return {
				step: payload.step + 1,
				title: payload.title,
				...getWizardData()
			}
		}
	},

	AddTagButton: {
		event: 'Add Tag Button Clicked UI',
		getData: getTagData
	},
	AddTagList: {
		event: 'Add Tag List Closed UI',
		getData: getTagData
	},
	AddTagItem: {
		event: 'Add Tag Item Selected UI',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	TagCreationFailure: {
		event: 'Tag Creation Failure',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	TagOnTimeline: {
		event: 'Tag On Timeline Selected UI',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	TagMenuOpened: {
		event: 'Tag Menu Opened Clicked UI',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	TagMenuEdit: {
		event: 'Tag Menu Edit Clicked UI',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	TagMenuDelete: {
		event: 'Tag Menu Delete Clicked UI',
		getData: (payload) => {
			return {
				tag_type: payload.tagType,
				tag_time: payload.tagTime,
				...getTagData(payload)
			}
		}
	},
	CreateHighlight: {
		event: 'Highlight From Tags Create Highlight',
		getData: getTagData
	},
	CreateHighlightFailure: {
		event: 'Highlight Generation Failure',
		getData: (payload) => {
			return {
				...getTagData(payload),
				highlightType: payload.highlightType
			}
		}
	},
	ClipFromTagButton: {
		event: 'Clip From Tag Button Clicked UI',
		getData: getTagData
	},
	VideoShared: {
		event: 'Video Shared',
		getData: (payload) => {
			return {
				...getEventData(payload),
				club_id: payload.mainEvent?.clubId,
				share_type: payload.shareType
			}
		}
	},
	VideoSharedOpened: {
		event: 'Opened Shared Video',
		getData: getEventData
	},
	VideoShareIntent: {
		event: 'Video Share Intent',
		getData: getEventData
	},
	VideoShareFailed: {
		event: 'Video Share Failed',
		getData: getEventData
	},
	VideoSharedPlatform: {
		event: 'Video Shared',
		getData: (payload) => {
			return {
				...getEventData(payload),
				target_platform: payload.provider
			}
		}
	},
	ExportVideoStarted: {
		event: 'Export Video Started',
		getData: getEventData
	},
	ExportVideoFailed: {
		event: 'Export Video Failed',
		getData: getEventData
	},
	DownloadVideoStarted: {
		event: 'Download Video Started',
		getData: getEventData
	},
	AudioDisabled: {
		event: 'Audio Disabled',
		getData: getEventData
	},
	PlayerModeChanged: {
		event: 'Player Mode Changed',
		getData: getEventData
	},
	PanoModeChanged: {
		event: 'Pano Mode Changed',
		getData: (payload) => {
			return {
				...getEventData(payload),
				internal_pano_mode: payload.panoMode
			}
		}
	},
	PanoRecordingStarted: {
		event: 'Pano Recording Started',
		getData: (payload) => {
			return {
				...getEventData(payload),
				internal_pano_mode: payload.panoMode
			}
		}
	},
	PanoRecordingSuccess: {
		event: 'Pano Recording Success',
		getData: (payload) => {
			return {
				...getEventData(payload),
				internal_pano_mode: payload.panoMode
			}
		}
	},
	PanoRecordingFailed: {
		event: 'Pano Recording Failed',
		getData: (payload) => {
			return {
				...getEventData(payload),
				internal_pano_mode: payload.panoMode
			}
		}
	},
	TagMemberListOpened: {
		event: 'Tag Member List Opened',
		getData: getTagMemberData
	},
	TagMemberChecked: {
		event: 'Tag Member Checked',
		getData: (payload) => {
			return {
				...getTagMemberData(payload),
				checked_user_id: payload.userId,
				clubId: payload.clubId
			}
		}
	},
	TagMemberUnchecked: {
		event: 'Tag Member Unchecked',
		getData: (payload) => {
			return {
				...getTagMemberData(payload),
				unchecked_user_id: payload.userId,
				clubId: payload.clubId
			}
		}
	},
	TagMemberOwnTagRemoved: {
		event: 'Tag Member Own Tag Removed',
		getData: getTagMemberData
	},
	TagMemberListClosed: {
		event: 'Tag Member List Closed',
		getData: getTagMemberData
	},
	UserFeedback: {
		event: 'User Left Feedback',
		getData: (payload) => {
			return {
				...getEventData(payload),
				club_id: payload.mainEvent?.clubId,
				viewed_videos: payload.playbackHistory,
				quantity_of_closed_feedback: payload.closedFeedbackQuantity,
				rating: payload.rating,
				user_comment: payload.userComment
			}
		}
	},
	UserClosedModalFeedback: {
		event: 'User Closed Feedback Modal',
		getData: (payload) => {
			return {
				...getEventData(payload),
				club_id: payload.mainEvent?.clubId,
				viewed_videos: payload.playbackHistory,
				quantity_of_closed_feedback: payload.closedFeedbackQuantity
			}
		}
	},
	UserTeamsStatus: {
		event: 'User Join Team Status',
		getData: (payload) => {
			return {
				...(payload.clubName && { team_name: payload.clubName }),
				...(payload.teamId && { team_id: payload.teamId }),
				client_type: 'Web',
				has_team: payload.hasTeams
			}
		}
	},
	AskToJoinButton: {
		event: 'Ask To Join Team Button Clicked',
		getData: (payload) => {
			return {
				...(payload.teamId && { team_id: payload.teamId }),
				...(payload.teamName && { team_name: payload.teamName }),
				...(payload.teamLocation && { team_location: payload.teamLocation }),
				team_list: payload.teamList,
				team_account_package: payload.teamAccountPackage,
				client_type: 'Web'
			}
		}
	},
	ResultsFound: {
		event: 'Join Team Results Found',
		getData: (payload) => {
			return {
				...(payload.teamId && { team_id: payload.teamId }),
				...(payload.clubName && { team_name: payload.clubName }),
				number_of_found_teams: payload.numberOfTeams,
				team_list: payload.teamList,
				client_type: 'Web'
			}
		}
	},
	JoinTeamButton: {
		event: 'Join Team Button Clicked',
		getData: (payload) => {
			return {
				...(payload.teamId && { team_id: payload.teamId }),
				...(payload.clubName && { team_name: payload.clubName }),
				client_type: 'Web'
			}
		}
	},
	TeamUpdate: {
		event: 'Team Update',
		getData: (payload) => {
			return {
				...(payload.id && { id: payload.id }),
				...(payload.color && { color: payload.color }),
				...(payload.name && { name: payload.name }),
				...(payload.sport && { sport: payload.sport }),
				...(payload.shortName && { shortName: payload.shortName }),
				...(payload.website && { website: payload.website }),
				...(payload.facebook && { facebook: payload.facebook }),
				...(payload.instagram && { instagram: payload.instagram })
			}
		}
	},
	UserUpdate: {
		event: 'User Update',
		getData: (payload) => {
			return {
				...(payload.email && { email: payload.email }),
				...(payload.name && { name: payload.name }),
				...(payload.phone && { phone: payload.phone })
			}
		}
	},
	JumpToLive: {
		event: 'Jump To Live Clicked',
		getData: (payload) => {
			return {
				...getEventData(payload),
				live_status: payload.liveStatus
			}
		}
	},
	TeamDelete: {
		event: 'Team Delete',
		getData: (payload) => {
			return {
				client_type: 'Web',
				...(payload.id && { id: payload.id }),
				...(payload.name && { name: payload.name }),
				...(payload.sport && { sport: payload.sport }),
				...(payload.role && { role: payload.role })
			}
		}
	},
	DeepLinkButtonViewed: {
		event: 'Viewed Deep Link',
		getData: (payload) => {
			const { mainEvent, selectedTeam } = payload
			return {
				event_id: mainEvent.eventId,
				team_id: mainEvent.clubId,
				team_name: selectedTeam.name,
				sport_type: mainEvent.sportType,
				type: 'match'
			}
		}
	},
	ChurnPreventionTriggerClicked: {
		event: 'Churn Prevention Trigger Clicked',
		getData: payload => ({
			trigger: payload.trigger,
			source: payload.source,
			subscription_id: payload.subscription?.id || payload.subscriptionId,
			subscription_type: payload.subscription?.type || payload.subscription?.metadata?.type,
			billing_period: payload.subscription?.intervalCount,
			client_type: 'Web'
		})
	},
	VidSwapUpsellTriggerClicked: {
		event: 'VidSwap Upsell Trigger Clicked',
		getData: payload => ({
			trigger: payload.trigger,
			source: payload.source,
			team_id: payload.team?.id || payload.teamId,
			team_name: payload.team?.name,
			event_id: payload.mainEvent?.eventId,
			sport_type: payload.mainEvent?.sportType || payload.team?.sportType,
			client_type: 'Web'
		})
	},
	PlanSelectedOnMarketing: {
		event: 'Marketing: Plan Selected',
		getData: (subscription) => {
			return {
				id: subscription.id,
				plan: subscription.metadata?.plan,
				subscription_name: (subscription.intervalCount === 1 ? 'Monthly' : subscription.intervalCount === 12 ? 'Yearly' : 'Two-years') + '/' + subscription.metadata.type,
				...getWizardData()
			}
		}
	},
	LitePlanOptionClicked: {
		event: 'Wizard: Lite Plan Option Selected',
		getData: () => {
			return getWizardData()
		}
	},
	/* Below is analytics for new wizard flow
	 ----------------------------------------------------------------
	 */
	WizardPurchaseUserStartedPurchaseFlow: {
		event: 'Wizard Purchase: User Started Purchase Flow',
		getData: (payload) => {
			return {
				email: payload.email,
				is_receive_news: payload.is_receive_news,
				...getWizardData()
			}
		}
	},
	WizardPurchaseSubscriptionTypeSelected: {
		event: 'Wizard Purchase: Subscription Type Selected',
		getData: (payload) => {
			return {
				subscription_type: payload.type,
				...getWizardData()
			}
		}
	},
	WizardPurchaseSportSelected: {
		event: 'Wizard Purchase: Sport Selected',
		getData: (sport) => {
			return {
				title: sport.title,
				...getWizardData()
			}
		}
	},
	WizardPurchaseCameraSelected: {
		event: 'Wizard Purchase: Camera Selected',
		getData: (camera) => {
			return {
				id: camera.id,
				type: (!camera.price ? 'I have my own/' : '') + camera.metadata.cameraType,
				...getWizardData()
			}
		}
	},
	WizardPurchaseAccessoriesQuantityChange: {
		event: 'Wizard Purchase: Accessories Quantity Changed',
		getData: (accessories) => {
			return Object.assign({ ...getWizardData() }, accessories.map(item => ({
				id: item.id,
				name: item.name,
				quantity: item.qty
			})))
		}
	},
	WizardPurchaseAccessoriesInfoClicked: {
		event: 'Wizard Purchase: Accessories Info Clicked UI',
		getData: (accessory) => {
			return {
				id: accessory.id,
				name: accessory.name,
				...getWizardData()
			}
		}
	},
	WizardPurchaseSubscriptionSelected: {
		event: 'Wizard Purchase: Subscription Selected',
		getData: (subscription) => {
			return {
				id: subscription.id,
				subscription_name: (subscription.intervalCount === 1 ? 'Monthly' : 'Yearly') + '/' + subscription.metadata.type,
				...getWizardData()
			}
		}
	},
	WizardPurchaseStep: {
		event: 'Wizard Purchase Step',
		getData: (payload) => {
			return {
				step: payload.step + 1,
				title: payload.title,
				...getWizardData()
			}
		}
	},
	WizardPurchaseRoleSelected: {
		event: 'Wizard Purchase: Role Selected',
		getData: (payload) => {
			return {
				...getWizardData(),
				role: payload.role
			}
		}
	},
	WizardPurchasePaymentMethodSelected: {
		event: 'Wizard Purchase: Payment Method Selected',
		getData: (payload) => {
			return {
				...getWizardData(),
				paymentMethod: payload.paymentMethod
			}
		}
	},
	WizardPurchaseSubmitClicked: {
		event: 'Wizard Purchase: Checkout Submit Clicked UI',
		getData: getWizardData
	},
	WizardPurchaseSubmitError: {
		event: 'Wizard Purchase: Submit Error',
		getData: (error) => {
			return {
				error,
				...getWizardData()
			}
		}
	},
	WizardPurchaseCheckoutFailed: {
		event: 'Wizard Purchase: Failed To Complete Checkout',
		getData: getWizardData
	},
	WizardPurchaseSignUpSuccess: {
		event: 'Wizard Purchase: Sign Up Successfully',
		getData: getWizardData
	}
}
